module.exports = {
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST',
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_SUCCESS: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_SUCCESS',
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_FAILURE: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_FAILURE',
  DEPARTURE_MAIL_PROCESSING_CENTER_CHECKED: 'DEPARTURE_MAIL_PROCESSING_CENTER_CHECKED',
  DEPARTURE_POSTAL_OPERATOR_EXPANDED: 'DEPARTURE_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS: 'SELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS',
  SELECT_ALL_DEPARTURE_OPERATORS: 'SELECT_ALL_DEPARTURE_OPERATORS',
  DESELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS: 'DESELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS',
  DESELECT_ALL_DEPARTURE_OPERATORS: 'DESELECT_ALL_DEPARTURE_OPERATORS',
  DEPARTURE_OPERATOR_CENTER_CHECKED: 'DEPARTURE_OPERATOR_CENTER_CHECKED',
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_ADMIN: 'DEPARTURE_POSTAL_OPERATOR_EXPANDED_ADMIN',
};
